//适配不同屏幕
var html = document.getElementsByTagName("html")[0];
function getFontSize(){
    var width=document.documentElement.clientWidth||document.body.clientWidth+"px";
	if(width>500){
		width = 500;
	}
    var fontSize=(100/750)*width;
    return fontSize;
}
html.style.fontSize=getFontSize()+"px";
window.onresize=function(){
    setTimeout(function(){
    html.style.fontSize=getFontSize()+"px";
    },100)
}